import { Box } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import { getFormattedCurrency } from '../../../utils/business/prices';
import LabelWithText from '../../generic/LabelWithText';

const labelProps = {
  labelSize: 'md',
  textSize: '10px',
  labelWeight: 'bold',
};

const AvailabilityPriceInfo = ({ product, priceWithoutPromo, price, maxBookableSessions }) => {
  const { free: isFree, price_per_participant: isPricePerParticipant } = product;

  const hasPromo = priceWithoutPromo != null && priceWithoutPromo > price;

  if (isFree) {
    return (
      <Box>
        <LabelWithText label={<Trans>Free</Trans>} text={<></>} {...labelProps} />
      </Box>
    );
  }

  return (
    <Box>
      <LabelWithText
        label={getFormattedCurrency(price)}
        text={hasPromo || isPricePerParticipant ? <></> : <Trans>per session</Trans>}
        {...labelProps}
      />

      {/* price without promo is the original price versus the price with calculated rules */}
      {hasPromo && (
        <LabelWithText
          label={getFormattedCurrency(priceWithoutPromo)}
          text={isPricePerParticipant ? <></> : <Trans>per session</Trans>}
          labelSize="sm"
          textSize="10px"
          strikeLabel
          labelColor="brand.color_alert_error_icon"
        />
      )}

      {!isPricePerParticipant && maxBookableSessions && (
        <LabelWithText label="" text={<Trans>({maxBookableSessions} available)</Trans>} {...labelProps} />
      )}
    </Box>
  );
};

export default AvailabilityPriceInfo;
